import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { linkStyles, pageStyles } from '../components/cssstyles.js';

@customElement('report-viewer-stub')
export class ReportViewerStub extends LitElement {
  override render() {
    return html`
      <sl-animation name=fadeIn easing=easeIn play delay=500 duration=500 iterations=1 fill=forwards>
        <v-box style="gap: var(--sl-spacing-2x-large); opacity: 0;">
          <!-- Worker chart -->
          <v-box>
            <sl-skeleton effect="pulse" style="height: 10px;"></sl-skeleton>
            <sl-skeleton effect="pulse" style="height: 10px;"></sl-skeleton>
          </v-box>

          <!-- Header -->
          <h-box style="align-items: start;">
            <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-3x-large); width: 7em; height: 3em;"></sl-skeleton>
            <x-filler></x-filler>
            <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-2x-large); width: 12em; height: 2em;"></sl-skeleton>
          </h-box>

          <!-- FQL -->
          <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-2x-large); height: 1em;"></sl-skeleton>

          <!-- summary -->
          <h-box>
            <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-2x-large); height: 2em; width: 7ch;"></sl-skeleton>
            <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-2x-large); height: 2em; width: 7ch;"></sl-skeleton>
            <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-2x-large); height: 2em; width: 7ch;"></sl-skeleton>
            <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-2x-large); height: 2em; width: 7ch;"></sl-skeleton>
            <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-2x-large); height: 2em; width: 7ch;"></sl-skeleton>
          </h-box>
          <!-- table -->
          <v-box style="gap: 0;">
            <!-- table tabs -->
            <h-box>
              <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-medium); height: 2em; width: 7ch;"></sl-skeleton>
              <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-medium); height: 2em; width: 7ch;"></sl-skeleton>
              <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-medium); height: 2em; width: 7ch;"></sl-skeleton>
              <x-filler></x-filler>
              <sl-skeleton effect="pulse" style="font-size: var(--sl-font-size-medium); height: 2em; width: 12ch;"></sl-skeleton>
            </h-box>
            <sl-divider></sl-divider>
            <sl-skeleton effect="pulse" style="height: 750px; --border-radius: var(--sl-border-radius-large);"></sl-skeleton>
          </v-box>
        </v-box>
      </sl-animation>
    `;
  }

  static styles = [linkStyles, pageStyles, css`
    sl-skeleton {
      --border-radius: var(--sl-border-radius-medium);
    }
  `]
}
